import script from "./FundLetterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FundLetterPage.vue?vue&type=script&setup=true&lang=js"

import "./FundLetterPage.vue?vue&type=style&index=0&id=2811fc7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2811fc7e"]])

export default __exports__